module.exports = __webpack_public_path__ + "live_title.42931781.png";